function handlePopover() {
    const popoverButton = document.querySelector('.site-header .Country__SwitchTop .SelectButton');

    if (!popoverButton) return;
    popoverButton.addEventListener('click', () => {
        const popoverContent = document.querySelector('#header-locale-popover');
        const isHidden = popoverContent.getAttribute('aria-hidden') === "true"
        const isExpanded = popoverButton.getAttribute('aria-expanded') === "true"

        popoverContent.setAttribute('aria-hidden', !isHidden);
        popoverButton.setAttribute('aria-expanded', !isExpanded);
    });
}

function handleMobileDropdown() {
    const popoverButton = document.getElementById('mobile-countryswitcher-button');

    if (!popoverButton) return;
    popoverButton.addEventListener('click', () => {
        const popoverContent = document.getElementById('header-locale-popover-mobile');
        const isHidden = popoverContent.getAttribute('aria-hidden') === "true"
        const isExpanded = popoverButton.getAttribute('aria-expanded') === "true"

        popoverContent.setAttribute('aria-hidden', !isHidden);
        popoverButton.setAttribute('aria-expanded', !isExpanded);
    });
}

document.addEventListener('DOMContentLoaded', () => {
    handlePopover();
    handleMobileDropdown();

    var specifiedElement = document.getElementById('header-locale-popover');
    
    document.addEventListener('click', function(event) {
        const popoverContent = document.querySelector('#header-locale-popover');
        const popoverButton = document.querySelector('.site-header .Country__SwitchTop .SelectButton');
        if (!popoverButton || !popoverContent) return;
        var isClickInside = specifiedElement.contains(event.target) || event.target === popoverButton || popoverButton.contains(event.target);

        if (!isClickInside) {
            popoverContent.setAttribute('aria-hidden', true);
            popoverButton.setAttribute('aria-expanded', false);
        }
    });
});
